<header class="ust" [class.acik]="isCondensed">
  <a class="logo" routerLink="/">
    <svg><use xlink:href="#lg"></use></svg> pratiu
  </a>
  <!--
  <nav>
    <a routerLink="/" routerLinkActive="on" [routerLinkActiveOptions]="{exact: true}">Ana sayfa</a>
    <a routerLink="/education-institutions" routerLinkActive="on">Eğitim Kurumları</a>
    <a routerLink="/corporates" routerLinkActive="on">Kurumsal Firmalar</a>
    <a routerLink="/teachers" routerLinkActive="on">Öğretmenler</a>
    <a routerLink="/students" routerLinkActive="on">Öğrenci / Veli</a>
    <a routerLink="/aboutus" [class.on]="kurumsalAktif">Kurumsal</a>
  </nav>
  <div class="sag">
    <a class="btn ikincil k" href="https://app.pratiu.com" target="_blank" rel="noopener">Giriş</a>
    <a class="btn kirmizi k" href="https://app.pratiu.com" target="_blank" rel="noopener">Hemen kayıt olun</a>
    <button class="ac" type="button" (click)="toggleMenu()" aria-label="Menü">☰</button>
  </div>
  -->
</header>
